import React, { useContext, createContext } from "react";
import PropTypes from "prop-types";

export const PlatformContext = createContext();

export const PlatformContextProvider = ({ children }) => {
    const { country, locale } = document.body.dataset;

    return (
        <PlatformContext.Provider
            value={{
                country,
                locale,
            }}
        >
            {children}
        </PlatformContext.Provider>
    );
};

PlatformContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const usePlatformContext = () => useContext(PlatformContext);
